var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Channel List" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "pb-6 flex justify-between items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "search channel name" },
                                on: { change: _vm.searchChannel },
                                model: {
                                  value: _vm.filter.q,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "q", $$v)
                                  },
                                  expression: "filter.q"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: { label: "Apply" },
                            on: { clicked: _vm.searchChannel }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            { staticClass: "p-2" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "sync"] },
                                on: { click: _vm.resetChannel }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: {
                          label: "Add Channel",
                          variant: "outline-primary"
                        },
                        on: { clicked: _vm.add }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableChannel",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [_vm.displayingItem]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom"
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "Actions",
                        align: "right",
                        "min-width": "100px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "static inline-block text-left container-action"
                                },
                                [
                                  _c(
                                    "VueCustomTooltip",
                                    {
                                      attrs: {
                                        label: "See Detail",
                                        position: "is-left"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "inline-block p-2 w-8 mb-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                          attrs: {
                                            href:
                                              "/#/missions-videos/channel-detail/" +
                                              scope.row.id
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "text-white",
                                            attrs: { icon: ["fa", "eye"] }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "VueCustomTooltip",
                                    {
                                      attrs: {
                                        label: "Edit",
                                        position: "is-left"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "p-2 w-8 mr-2 mb-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                          on: {
                                            click: function($event) {
                                              return _vm.edit(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "text-white",
                                            attrs: {
                                              icon: ["fa", "pencil-alt"]
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "VueCustomTooltip",
                                    {
                                      attrs: {
                                        label: "Delete",
                                        position: "is-left"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "w-8 mr-2 mb-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteChannel(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "text-white",
                                            attrs: { icon: ["fa", "trash-alt"] }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addSong",
          attrs: {
            isShowingModal: _vm.isShowingModalForm,
            title: _vm.titleModal,
            labelSubmit: "Submit"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalForm = !_vm.isShowingModalForm
            },
            save: function($event) {
              return _vm.submitFormChannel()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("ChannelForm", {
                ref: "channelForm",
                attrs: {
                  "toggle-reset": _vm.isShowingModalForm,
                  channel: _vm.selectedRow
                },
                on: { "on-submit-channel": _vm.onSubmitForm }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e3aa82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e3aa82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Channel/ChannelList.vue
// module id = null
// module chunks = 